interface QuickSelectorProps {
  selectedModel: string;
  onSelectModel: (model: string) => void;
}

const models = [
  {
    id: 'a-solo',
    name: 'A-Solo',
    series: 'A Series',
    image: '/images/ai-a-modern-minimalist-single-person-space--01e067.webp',
    size: '3m × 2.5m × 2.8m'
  },
  {
    id: 'a-team',
    name: 'A-Team',
    series: 'A Series',
    image: '/images/ai-a-contemporary-medium-sized-space-capsul-1732c1.webp',
    size: '6m × 3m × 2.8m'
  },
  {
    id: 'a-pro',
    name: 'A-Pro',
    series: 'A Series',
    image: '/images/ai-a-premium-large-scale-space-capsule-pod--fa3414.webp',
    size: '9m × 4m × 3m'
  },
  {
    id: 'z-compact',
    name: 'Z-Compact',
    series: 'Z Series',
    image: '/images/ai-a-sleek-compact-z-series-space-capsule-p-810bed.webp',
    size: '4m × 2.8m × 2.8m'
  },
  {
    id: 'z-standard',
    name: 'Z-Standard',
    series: 'Z Series',
    image: '/images/ai-a-modern-standard-z-series-space-capsule-8ed32d.webp',
    size: '6m × 3.5m × 3m'
  },
  {
    id: 'z-premium',
    name: 'Z-Premium',
    series: 'Z Series',
    image: '/images/ai-a-luxurious-premium-z-series-space-capsu-ff418c.webp',
    size: '9m × 4.5m × 3.2m'
  }
];

export default function QuickSelector({ selectedModel, onSelectModel }: QuickSelectorProps) {
  return (
    <>
      {/* Desktop Sidebar - Sticky */}
      <div className="hidden lg:block">
        <div className="sticky top-40">
          <div className="bg-gray-900/40 backdrop-blur-xl border border-gray-500/20 rounded-2xl p-6">
            <h3 className="text-lg font-semibold text-white mb-6 flex items-center gap-2">
              <i className="ri-list-check text-cyan-400 text-xl"></i>
              Quick Selection
            </h3>
            
            <div className="space-y-3">
              {models.map((model) => (
                <button
                  key={model.id}
                  onClick={() => onSelectModel(model.id)}
                  className={`w-full text-left p-4 rounded-xl transition-all cursor-pointer group ${
                    selectedModel === model.id
                      ? 'bg-cyan-500/20 border-2 border-cyan-400 shadow-[0_0_20px_rgba(0,217,255,0.3)]'
                      : 'bg-gray-800/40 border border-gray-500/20 hover:bg-gray-800/60 hover:border-gray-400/40'
                  }`}
                >
                  <div className="flex items-center gap-4">
                    <div className="w-20 h-16 rounded-lg overflow-hidden flex-shrink-0">
                      <img 
                        src={model.image} 
                        alt={model.name}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-xs text-cyan-400 mb-1">{model.series}</div>
                      <div className={`text-sm font-semibold mb-1 ${
                        selectedModel === model.id ? 'text-white' : 'text-gray-300 group-hover:text-white'
                      }`}>
                        {model.name}
                      </div>
                      <div className="text-xs text-gray-400">{model.size}</div>
                    </div>
                    {selectedModel === model.id && (
                      <i className="ri-check-line text-cyan-400 text-xl flex-shrink-0"></i>
                    )}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Top Bar - Vertical Stack */}
      <div className="lg:hidden mb-8 w-full">
        <div className="bg-gray-900/40 backdrop-blur-xl border border-gray-500/20 rounded-2xl p-4 w-full">
          <h3 className="text-base font-semibold text-white mb-4 flex items-center gap-2">
            <i className="ri-list-check text-cyan-400 text-lg"></i>
            Select Model
          </h3>
          
          <div className="grid grid-cols-2 gap-3 w-full">
            {models.map((model) => (
              <button
                key={model.id}
                onClick={() => onSelectModel(model.id)}
                className={`w-full p-3 rounded-xl transition-all cursor-pointer ${
                  selectedModel === model.id
                    ? 'bg-cyan-500/20 border-2 border-cyan-400 shadow-[0_0_20px_rgba(0,217,255,0.3)]'
                    : 'bg-gray-800/40 border border-gray-500/20'
                }`}
              >
                <div className="w-full aspect-[4/3] rounded-lg overflow-hidden mb-2">
                  <img 
                    src={model.image} 
                    alt={model.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-xs text-cyan-400 mb-1">{model.series}</div>
                <div className={`text-sm font-semibold ${
                  selectedModel === model.id ? 'text-white' : 'text-gray-300'
                }`}>
                  {model.name}
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}